import { supabase } from "../lib/supabase";

const CACHE_TTL_MS = 5_000;
const profileCache = new Map();
const accessCache = new Map();

export const instructorAccessService = {
  async getProfile(userId) {
    const cached = profileCache.get(userId);
    if (cached && cached.expiresAt > Date.now()) return cached.promise;

    const promise = supabase
      .from("instructor_profiles")
      .select("approval_status, rejection_reason")
      .eq("id", userId)
      .maybeSingle()
      .then(({ data, error }) => {
        if (error) throw error;
        return data;
      })
      .catch((error) => {
        profileCache.delete(userId);
        throw error;
      });

    profileCache.set(userId, {
      promise,
      expiresAt: Date.now() + CACHE_TTL_MS,
    });
    return promise;
  },

  async getAccess(userId) {
    const cached = accessCache.get(userId);
    if (cached && cached.expiresAt > Date.now()) return cached.promise;

    const promise = Promise.all([
      this.getProfile(userId),
      supabase
        .from("partner_instructors")
        .select("id")
        .eq("instructor_id", userId)
        .eq("status", "active")
        .limit(1)
        .maybeSingle(),
      supabase
        .from("partners")
        .select("id")
        .eq("admin_id", userId)
        .eq("status", "active")
        .limit(1)
        .maybeSingle(),
    ])
      .then(([profile, poolResult, partnerAdminResult]) => {
        if (poolResult.error) throw poolResult.error;
        if (partnerAdminResult.error) throw partnerAdminResult.error;
        return {
          profile,
          partnerApproved: !!poolResult.data,
          partnerAdmin: !!partnerAdminResult.data,
        };
      })
      .catch((error) => {
        accessCache.delete(userId);
        throw error;
      });

    accessCache.set(userId, {
      promise,
      expiresAt: Date.now() + CACHE_TTL_MS,
    });
    return promise;
  },

  invalidate(userId) {
    if (userId) {
      profileCache.delete(userId);
      accessCache.delete(userId);
    } else {
      profileCache.clear();
      accessCache.clear();
    }
  },
};
